import React from 'react'
import {identity} from 'lodash'

type BooleanState = boolean
type BooleanToggleFn = (...args: any[]) => any
type BooleanOnFn = (...args: any[]) => any
type BooleanOffFn = (...args: any[]) => any

type CallbackHandler = (...args: any[]) => any

export type BooleanResult = [
  BooleanState,
  BooleanToggleFn,
  BooleanOnFn,
  BooleanOffFn
]

export default function useBooleanState(
  initialBooleanState: BooleanState,
  callbackHandler: CallbackHandler = identity
): BooleanResult {
  const [booleanState, setBooleanState] = React.useState<BooleanState>(initialBooleanState)

  const booleanToggleFn: BooleanToggleFn = React.useCallback<BooleanToggleFn>(
    (...args) => {
      setBooleanState(!booleanState)
      return callbackHandler(...args, !booleanState)
    },
    [callbackHandler, booleanState]
  )

  const booleanOnFn: BooleanOnFn = React.useCallback<BooleanToggleFn>(
    (...args) => {
      setBooleanState(true)
      return callbackHandler(...args, true)
    },
    [callbackHandler]
  )

  const booleanOffFn: BooleanOffFn = React.useCallback<BooleanToggleFn>(
    (...args) => {
      setBooleanState(false)
      return callbackHandler(...args, false)
    },
    [callbackHandler]
  )

  return [
    booleanState,
    booleanToggleFn,
    booleanOnFn,
    booleanOffFn
  ]
}
